import {Constants} from "./Constants";
import _ from "lodash";

export let InvoiceDataUtility = {
    fpServiceTypeToClass: function (fpServiceType) {
        if (fpServiceType === Constants.fpServiceTypeNames.internalService) {
            return 'internal-service'
        } else if (fpServiceType === Constants.fpServiceTypeNames.internalExpense) {
            return 'internal-expense'
        } else if (fpServiceType === Constants.fpServiceTypeNames.externalExpense) {
            return 'external-expense'
        } else {
            return ''
        }
    },

    invoiceStatusToClass: function (invoiceStatus) {
        if (invoiceStatus.name === Constants.invoiceStatusNames.billed) {
            return 'billed';
        } else if (invoiceStatus.name === Constants.invoiceStatusNames.paid) {
            if (invoiceStatus.pending_stripe_payout) {
                return 'paid-pending-stripe-payout'
            } else {
                return 'paid'
            }
        } else {
            return 'not-tracked'
        }
    },

    getFormattedFpInvoiceItemName: function (fpInvoiceItem) {
        let phaseNameSafe = fpInvoiceItem.phaseName || '';
        let itemNameSafe = fpInvoiceItem.name || '';
        return `${phaseNameSafe} - ${itemNameSafe}`
    },

    fpInvoiceItemsGroupedByPhaseName: function (fpInvoiceItems) {
        let invoiceItemsByFpPhaseName = {};
        for (let v = 0; v < fpInvoiceItems.length; v++) {
            let fpInvoiceItem = fpInvoiceItems[v];
            if (!invoiceItemsByFpPhaseName[fpInvoiceItem.phaseName]) {
                invoiceItemsByFpPhaseName[fpInvoiceItem.phaseName] = {
                    name: fpInvoiceItem.phaseName,
                    amount: 0.0
                }
            }
            invoiceItemsByFpPhaseName[fpInvoiceItem.phaseName].amount += parseFloat(fpInvoiceItem.total)
        }

        let itemsGroupedByPhaseName = Object.values(invoiceItemsByFpPhaseName);
        for (let i = 0; i < itemsGroupedByPhaseName.length; i++) {
            itemsGroupedByPhaseName[i].amount = itemsGroupedByPhaseName[i].amount.toFixed(2)
        }

        return itemsGroupedByPhaseName
    },

    fpInvoiceItemsGroupedByServiceType: function (fpInvoiceItems) {
        let invoiceItemsByFpServiceType = {};
        for (let v = 0; v < fpInvoiceItems.length; v++) {
            let fpInvoiceItem = fpInvoiceItems[v];
            if (!invoiceItemsByFpServiceType[fpInvoiceItem.fp_service_type_name]) {
                invoiceItemsByFpServiceType[fpInvoiceItem.fp_service_type_name] = {
                    invoice_line_type_id: Constants.qboInvoiceLineTypes.custom,
                    name: fpInvoiceItem.fp_service_type_name + 's',
                    amount: 0.0,
                    fp_service_type_id: fpInvoiceItem.fp_service_type_id,
                    fp_service_type_name: fpInvoiceItem.fp_service_type_name,
                }
            }
            invoiceItemsByFpServiceType[fpInvoiceItem.fp_service_type_name].amount += parseFloat(fpInvoiceItem.amount)
        }

        let itemsGroupedByServiceType = Object.values(invoiceItemsByFpServiceType);
        for (let i = 0; i < itemsGroupedByServiceType.length; i++) {
            itemsGroupedByServiceType[i].amount = itemsGroupedByServiceType[i].amount.toFixed(2)
        }

        return itemsGroupedByServiceType
    },

    getInvoiceLineFieldId: function (arrayFieldName, idString, index) {
        return `${arrayFieldName}_${idString}_${index}`;
    },

    getOneOffInvoiceLinesSum(invoiceLines) {
        return _.chain(invoiceLines)
            .map((invoiceLine) => parseFloat(invoiceLine.amount))
            .sum()
            .value();
    }
}
